<template>
	<div class="stretch-layout">
		<card v-if="pageStyle.content" xs-tile sm-tile>
			<card-text>
				<user-content :text="pageStyle.content"/>
			</card-text>
		</card>
		<template v-if="products.length">
			<card v-for="(product, key) in products" :key="'product-' + key" xs-tile sm-tile>
				<card-text>
					<event-product :product="product"/>
				</card-text>
			</card>
		</template>
		<missing-info v-else :text="$t('missing.event.participation_products')" xs-tile sm-tile card min-height="500"/>
	</div>
</template>

<script setup lang="ts">
import {EventPageType, EventProductPurchaseLocation} from "@spoferan/spoferan-ts-core";
import {useEventStore} from "../../../store/event";

const eventStore = useEventStore();
const {t} = useI18n();
const {$web, $api, $date} = useNuxtApp();

let pageStyle = {};
let products = [];

// Make sure the page is activated
const page = eventStore.getPage(EventPageType.Products);
if (!page) {
	await navigateTo($web('events.show', eventStore.event._key));
} else {
	const responses = await Promise.all([
		useApiFetch($api('events.pages.show', [eventStore.event.id, page.id]), {
			guest: true,
			params: {
				ts: page.cache_buster,
			}
		}),
		useApiFetch($api('events.products.index', eventStore.event._key), {
			guest: true,
			params: {
				only_visible: true,
				relations: ['participationClasses', 'prices', 'cancelConditions'],
				purchase_location: [EventProductPurchaseLocation.Participation, EventProductPurchaseLocation.ParticipationAndShop]
			}
		})
	]);

	pageStyle = responses[0].data
	products = responses[1].data;
}

useMeta({
	title: eventStore.buildPageTitle(t('view.events.products.index.title', {event: eventStore.event.display_name})),
	description: t('view.events.products.index.description', {event: eventStore.event.display_name}),
});
</script>

